import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import Comission from 'services/Comission'
import General from 'services/General'
import AdminNavbar from 'components/Navbars/AdminNavbar'
import MonthlyCutileiServicesModal from 'pages/Admin/Modals/MonthlyCutileiServicesModal'
import { DateTime } from 'luxon'

import { 
  Container,
  BusinessContainer,
  LabelRow,
  SubTitle,
  MoneyTextMask
} from '../../styles'

export default function AdminMonthlyExpenses () {
  const location = useLocation ()
  const [selectedSchedules, setSelectedSchedules] = useState (null)
  const [showDetails, setShowDetails] = useState (false)
  const { dateRange, monthExpenses, businessExpenses, professionalExpenses } = location.state
  const startDate = dateRange ? DateTime.fromISO (dateRange[0]).toFormat ('dd/MM/yyyy') : null
  const endDate = dateRange ? DateTime.fromISO (dateRange[1]).toFormat ('dd/MM/yyyy') : null
  const cutileiFilter = { value: 'cutilei' }

  const schedulesByMonth = location.state.schedulesByMonth.map (schedule => ({
    ...schedule,
    business_id: schedule.business.id
  }))

  const schedulesByBusiness = General.groupBy (schedulesByMonth, 'business_id')

  const handleSelect = schedules => {
    setSelectedSchedules (schedules)
    setShowDetails (true)
  }

  return (
    <Container>
      <AdminNavbar/>
      <SubTitle>{`Total do período - ${startDate} a ${endDate}`}</SubTitle>
      <LabelRow style={{gridTemplateColumns: 'repeat(4, 1fr)'}}>
        <SubTitle>Salão</SubTitle>
        <SubTitle>Despesa total</SubTitle>
        <SubTitle>Comissão dos salões</SubTitle>
        <SubTitle>Comissão dos profissionais</SubTitle>
      </LabelRow>
      <BusinessContainer style={{cursor: 'default'}}>
        <SubTitle>TOTAL</SubTitle>
        <MoneyTextMask value={monthExpenses}/>
        <MoneyTextMask value={businessExpenses}/>
        <MoneyTextMask value={professionalExpenses}/>
      </BusinessContainer>
      {schedulesByBusiness.map ((schedules, index) => {
        const { business } = schedules[0]
        const totalExpenses = Comission.getTotalEarnings (schedules, cutileiFilter)
        const businessExpenses = Comission.getBusinessEarnings (schedules, cutileiFilter)
        const professionalExpenses = Comission.getProfessionalEarnings (schedules, cutileiFilter)

        return (
          <BusinessContainer key={index} onClick={() => handleSelect (schedules)}>
            <SubTitle>{business.name}</SubTitle>
            <MoneyTextMask value={totalExpenses}/>
            <MoneyTextMask value={businessExpenses}/>
            <MoneyTextMask value={professionalExpenses}/>
          </BusinessContainer>
        )
      })}
      <MonthlyCutileiServicesModal
        visible={showDetails}
        schedules={selectedSchedules}
        dateRange={dateRange}
        onClose={() => setShowDetails (false)}
      />
    </Container>
  )
}
